import { lazy } from 'react';

import { MonteraRoute } from 'src/utils/router';

export const ReportsRoute: MonteraRoute<'reports'> = {
  name: 'reports',
  path: '/reports',
  comp: () => lazy(() => import('./index')),
};
